import Immutable, { Record } from 'immutable';
import { DAILY, HOURLY, MONTHLY, WEEKLY } from './resolution';
import { CUSTOM, LAST_SEVEN_DAYS, TODAY } from './period';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(advancedFormat);

var GraphFields = Record({
  spotId: null,
  resolution: DAILY,
  points: [],
  enabled: [],
  period: LAST_SEVEN_DAYS
});

const DEFAULT_FORMAT = 'MMMM Do YYYY';

export function getMonthPoints(points) {
  return points.map(point => {
    if (!point) {
      return {};
    }
    var time = point.x;
    return {
      x: new Date(time),
      y: point.y,
      meta: `${dayjs(time).utc().format(DEFAULT_FORMAT)}`
    };
  });
}

export function getWeeksPoints(points) {
  if (points.length == 0) return [];
  var weeklyPoints = [];
  var normalizePoints = [];
  if (points.length < 9) {
    let y = points.map(day => (day ? day.y : 0)).reduce((previous, current) => previous + current);
    let time = points[points.length - 1].x;
    normalizePoints.push({
      y,
      x: new Date(time),
      meta: `${dayjs(time).utc().subtract(points.length, 'days').format(DEFAULT_FORMAT)} - ${dayjs(
        time
      )
        .utc()
        .format(DEFAULT_FORMAT)}`
    });
  } else {
    for (var i = 0; i < points.length; i += 7) {
      weeklyPoints.push(points.slice(i, i + 7));
    }
    weeklyPoints.forEach(week => {
      if (!week[0]) {
        normalizePoints.push({});
        return;
      }
      let y = week.map(day => (day ? day.y : 0)).reduce((previous, current) => previous + current);

      var fromDay = week[0].x;
      var toDay = week[week.length - 1].x;
      normalizePoints.push({
        y: y,
        x: new Date(fromDay),
        meta: `${dayjs(fromDay).utc().format(DEFAULT_FORMAT)} - ${dayjs(toDay)
          .utc()
          .format(DEFAULT_FORMAT)}`
      });
    });
  }

  return normalizePoints;
}

export const getDailyPoints = (points, period, popPoint) => {
  if (popPoint && period && period !== CUSTOM) {
    points.pop();
  }
  return points.map(point => {
    if (!point) {
      return {};
    }
    var time = point.x;
    return {
      x: new Date(time),
      y: point.y,
      meta: `${dayjs(time).utc().format('dddd')}, ${dayjs(time).utc().format(DEFAULT_FORMAT)}`
    };
  });
};

export function getHourlyPoints(points, period, popPoint) {
  if (popPoint && period === TODAY) {
    points.pop();
  }

  return points.map(point => {
    if (!point) {
      return {};
    }
    var time = point.x;
    return {
      x: new Date(time),
      y: point.y,
      meta: dayjs(time).utc().format(`${DEFAULT_FORMAT}, HH:mm`)
    };
  });
}

class Graph extends GraphFields {
  parse(data) {
    if (!data) {
      return this;
    }

    var fields = {};

    ['spotId', 'resolution', 'points', 'enabled', 'period'].forEach(
      field => (fields[field] = data[field] !== undefined ? data[field] : this.get(field))
    );

    switch (data.resolution) {
      case HOURLY:
        fields.points = getHourlyPoints(data.points, data.period || this.period, data.popPoint);
        break;
      case DAILY:
        fields.points = getDailyPoints(data.points, data.period || this.period, data.popPoint);
        break;
      case WEEKLY:
        fields.points = getWeeksPoints(data.points);
        break;
      case MONTHLY:
        fields.points = getMonthPoints(data.points);
        break;
    }
    var newGraph = new Graph(fields);
    return Immutable.is(this, newGraph) ? this : newGraph;
  }
}

export default Graph;
